export default "__VITE_ASSET__Dyq9RZ2u__"